import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristfamilydetails",
  inputs: [
    {
      name: "number_of_family_members",
      label: "Number of family members",
      placeholder: "5",
      type: InputType.CountedTextInput,
      minLength: 1,
      maxLength: 200,
    },
    {
      name: "father_name",
      label: "Father Name",
      placeholder: "Vijay Kumar",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "occupation_of_father",
      label: "Occupation of Father",
      placeholder: "Teacher",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "mother_name",
      label: "Mother Name",
      placeholder: "Rukmani",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "occupation_of_mother",
      label: "Occupation of Mother",
      placeholder: "Teacher",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      label: "Are you married ?",
      type: InputType.InputCluster,
      cols: 2,
      fields: [
        {
          name: "spouse_name",
          label: "Spouse Name",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "occupation_of_spouse",
          label: "Occupation of Spouse ",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Do you have children ?",
      type: InputType.InputCluster,
      cols: 2,
      fields: [
        {
          name: "no_of_children",
          label: "Number of childrens",
          placeholder: "1",
          type: InputType.CountedTextInput,
          minLength: 1,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Do you have any siblings ?",
      type: InputType.InputCluster,
      cols: 2,
      fields: [
        {
          name: "no_of_sibling",
          label: "How many siblings do you have?",
          placeholder: "2",
          type: InputType.CountedTextInput,
          minLength: 1,
          maxLength: 100,
        },
        {
          name: "name_of_sibling",
          label: "Sibling Name",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "occupation_of_sibling",
          label: "Occupation of Sibling ",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
  ],
};

export default formFields;
